import React, { useState, useEffect } from "react"
import "./application.scss"


import Layout from '../components/application/Layout'
import Main from "../components/application/Main"

export default function Application() {

    const [model, setModel] = useState("Species Based")

    return (
        <Layout title="Application | Multi-Regional Social Accounting Matrix" getModel={(value) => {setModel(value)}}>
            <div id="Species"
                className={model === "Species Based" ? 'Report' : 'Report_hidden'}>
                <Main selector="#Species" model="Species" />
            </div>
            <div id="Gear"
                className={model === "Gear Based" ? 'Report' : 'Report_hidden'}>
                <Main selector="#Gear" model="Gear" />
            </div>
            <div id="Charter"
                className={model === "Charter Based" ? 'Report' : 'Report_hidden'}>
                <Main selector="#Charter" model="Charter" />
            </div>
        </Layout>
    )
}
